// extracted by mini-css-extract-plugin
module.exports = {"link":"Clickable-module-link","iframe":"Clickable-module-iframe","button":"Clickable-module-button"};